export const ADD_ITEM_IN_WISHLIST = "ADD_ITEM_IN_WISHLIST";
export const REMOVE_ITEM_FROM_WISHLIST = "REMOVE_ITEM_FROM_WISHLIST";
